// extracted by mini-css-extract-plugin
module.exports = {"appMain":"app_appMain__1WD4g"};